// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.yeah[data-v-3c6f3518] {
  font-family: fantasy;
}
`, "",{"version":3,"sources":["webpack://./src/views/UnknownPanel.vue"],"names":[],"mappings":";AAgBA;EACE,oBAAoB;AACtB","sourcesContent":["<template>\n  <div id=\"home\">\n    <h1>\n      Oops! Can’t find the <code>#{{ $specialPage }}</code> page.\n    </h1>\n    <p>⚠️ Something’s wrong and we can’t find that page.</p>\n    <p class=\"yeah\">This is probably a bug.</p>\n    <!-- Report a bug here? -->\n  </div>\n</template>\n\n<script>\nexport default {};\n</script>\n\n<style scoped>\n.yeah {\n  font-family: fantasy;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
